import React from 'react'
import { useLocation } from 'react-router-dom';
import Image from "../../assets/armypatch.png";

const Back = ({title}) => {
    const location = useLocation();
    return (
        <>
            
         
        </>
    )
}

export default Back
